import { render, staticRenderFns } from "./LabelContractsAdvanceEditPanelDialog.vue?vue&type=template&id=19d70d52"
import script from "./LabelContractsAdvanceEditPanelDialog.vue?vue&type=script&lang=js"
export * from "./LabelContractsAdvanceEditPanelDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports